var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-principal-parts__item" },
    [
      _vm.lemmaindex === 0 && _vm.printIndex
        ? _c("span", { staticClass: "alpheios-principal-parts__lemma_index" }, [
            _vm._v(_vm._s(_vm.lexemeindex + 1)),
          ])
        : _vm.lemmaindex > 0 && _vm.printIndex
        ? _c("span", {
            staticClass: "alpheios-principal-parts__lemma_index_spacer",
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.lemma.principalParts.includes(_vm.lemma.displayWord)
        ? _c(
            "h4",
            {
              staticClass:
                "alpheios-principal-parts__groupitem alpheios-principal-parts__groupitem--lemma-word",
              attrs: { lang: _vm.languageCode, "data-alpheios-enable": "all" },
            },
            _vm._l(_vm.wordParts(_vm.lemma.displayWord), function (word) {
              return _c(
                "div",
                {
                  key: word,
                  staticClass:
                    "alpheios-principal-parts__groupitem--lemma-word__listitem",
                },
                [_vm._v(_vm._s(word))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.lemma.principalParts && _vm.lemma.principalParts.length > 0
        ? _c(
            "h4",
            { staticClass: "alpheios-principal-parts__groupitem" },
            _vm._l(_vm.lemma.principalParts, function (part, partIndex) {
              return _c(
                "span",
                {
                  key: partIndex,
                  staticClass: "alpheios-principal-parts__listitem",
                  attrs: {
                    lang: _vm.languageCode,
                    "data-alpheios-enable": "all",
                  },
                },
                [_vm._v(_vm._s(part))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.disambiguated,
              expression: "disambiguated",
            },
          ],
          staticClass: "alpheios-principal-parts__pointer-tooltip",
          attrs: {
            "tooltip-text": _vm.l10n.getText("TOOLTIP_DISAMBIGUATED"),
            "tooltip-direction": "top",
          },
        },
        [
          _c("disambiguated-icon", {
            staticClass:
              "alpheios-principal-parts__pointer-icn alpheios-disambiguated-icon",
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.disambiguated,
              expression: "disambiguated",
            },
          ],
          staticClass: "alpheios-principal-parts__dsmbg-providers",
        },
        [
          _c(
            "tooltip",
            {
              staticClass: "alpheios-principal-parts__dsmbg-providers-tooltip",
              attrs: {
                "tooltip-text": _vm.l10n.getText("TOOLTIP_TREEBANK_SOURCE"),
                "tooltip-direction": "top",
              },
            },
            [
              _c("treebank-icon", {
                staticClass:
                  "alpheios-principal-parts__dsmbg-providers-icn alpheios-treebank-icon",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("inflectionattribute", {
        attrs: {
          data: _vm.lemma.features,
          decorators: ["brackets", "appendspace", "chinese"],
          type: _vm.types.pronunciation,
        },
      }),
      _vm._v(" "),
      _vm.hasExtras
        ? _c(
            "div",
            { staticClass: "feature_extras" },
            [
              _c("inflectionattribute", {
                attrs: {
                  data: _vm.featureList(
                    ["age", "area", "geo", "frequency"],
                    "extras"
                  ),
                  type: "extras",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasSource
        ? _c(
            "div",
            { staticClass: "feature_source" },
            [
              _c("inflectionattribute", {
                attrs: {
                  data: _vm.lemma.features,
                  decorators: ["link", "brackets"],
                  type: _vm.types.source,
                  lang: _vm.languageCode,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }